import { render, staticRenderFns } from "./RowRequests.vue?vue&type=template&id=52c36b8e"
import script from "./RowRequests.vue?vue&type=script&lang=js"
export * from "./RowRequests.vue?vue&type=script&lang=js"
import style0 from "./RowRequests.vue?vue&type=style&index=0&id=52c36b8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports